<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><span>Cast a cold eye</span></p>
<p class="centera1"><span>on life, on death,</span></p>
<p class="centera1"><span>horseman pass by.</span></p>
<p class="right"><span>—William Butler Yeats</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?a086d144